import { useInfiniteQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'
import { getUploadedFiles } from '../api'
import type { UploadedFilesResponse } from '../types'

export interface UploadedFilesQueryParams {
  limit?: number
}
export function useUploadedFilesQuery(params: UploadedFilesQueryParams = {}) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useInfiniteQuery<UploadedFilesResponse>({
    queryKey: ['uploaded-files', organization?.id, params],
    queryFn: async ({ pageParam }) => {
      const token = await getToken()
      if (!token) {
        throw new Error('No authentication token available')
      }
      return getUploadedFiles(token, params, pageParam as string | undefined)
    },
    getNextPageParam: (lastPage) =>
      lastPage.pagination.next_cursor ?? undefined,
    initialPageParam: undefined,
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
